module.exports = __webpack_public_path__ + "fonts/AkkBd_Pro_1.a536083.otf";